import { useTranslate } from '@tolgee/react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useMemoizedFn, useRequest } from 'ahooks';
import { FilterState } from '../hooks/useFilter';
import { StatusFilter, useGetReturnListParams } from '../hooks/useReturnList';
import { exportReturnList, SecondaryProcessStatus } from 'services/api/refund';
import { useExportFile } from 'components/ExportCenter/hooks/useExportCenter';
import { getLocalTimeZone } from 'utils/timeZone';

interface ExportButtonProps {
  query: FilterState;
  statusFilter: StatusFilter;
  secondaryProcessStatus: SecondaryProcessStatus;
  platform: General.PlatformUpperCase;
}

export const ExportButton = (props: ExportButtonProps) => {
  const { query, statusFilter, secondaryProcessStatus, platform } = props;
  const { t } = useTranslate();
  const getReturnListParams = useGetReturnListParams();
  const { run, loading: exportLoading } = useExportFile();

  const { runAsync: exportList } = useRequest(
    async () => {
      const data = await getReturnListParams(query, statusFilter, secondaryProcessStatus, platform);
      return exportReturnList({
        ...data,
        timeZone: getLocalTimeZone(),
      });
    },
    {
      manual: true,
    },
  );

  const handleExport = useMemoizedFn(() => {
    run(exportList);
  });

  return (
    <Button icon={<DownloadOutlined />} loading={exportLoading} onClick={handleExport}>
      {t('导出退单明细')}
    </Button>
  );
};
